import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import en from "./en";
import it from "./it";

const translations = { en, it };
const SUPPORTED_LANGUAGES = Object.keys(translations);

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem("language");
    return stored && SUPPORTED_LANGUAGES.includes(stored) ? stored : "en";
  });

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const switchLanguage = useCallback((lang) => {
    const nextLang = SUPPORTED_LANGUAGES.includes(lang) ? lang : "en";
    setLanguage(nextLang);
    localStorage.setItem("language", nextLang);
  }, []);

  const t = useCallback(
    (key) => {
      const keys = key.split(".");
      const activeLanguage = SUPPORTED_LANGUAGES.includes(language) ? language : "en";
      let value = translations[activeLanguage] || translations.en;
      for (const k of keys) {
        if (value === undefined) return key;
        value = value[k];
      }
      return value !== undefined ? value : key;
    },
    [language]
  );

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within a LanguageProvider");
  return ctx;
}
